module.exports = __webpack_public_path__ + "img/paypal.997b4148.svg";